import { render, staticRenderFns } from "./zendesk-jira.vue?vue&type=template&id=7eea0044&scoped=true"
import script from "./zendesk-jira.vue?vue&type=script&lang=js"
export * from "./zendesk-jira.vue?vue&type=script&lang=js"
import style0 from "./zendesk-jira.vue?vue&type=style&index=0&id=7eea0044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eea0044",
  null
  
)

export default component.exports